module.exports = __webpack_public_path__ + "static/media/team_alexD.812c75d9.jpg";